



































import { Vue, Component } from 'vue-property-decorator'
import { TelaDeLoja } from '@/shareds/preferencia-da-tela-de-loja'
import { TEXTOS_DA_TROCA } from './textos-da-troca'

export type RespostaSobreAlteracoes = 'salvar' | 'descartar' | 'continuar'

/** O que fazer com o que não foi salvo antes de trocar de tela. A troca em si é direta, nos dois sentidos. */
@Component
export default class DialogoDeTrocaDeTelaDaLoja extends Vue {
	TEXTOS = TEXTOS_DA_TROCA
	mostra = false
	destino: TelaDeLoja = 'antiga'
	alteracoes: string[] | null = null
	lojaNova = false
	resolver: ((resposta: RespostaSobreAlteracoes) => void) | null = null

	/** alteracoes null: a tela não sabe dizer o que mudou, só que mudou (a antiga). */
	perguntarSobreAlteracoes(destino: TelaDeLoja, alteracoes: string[] | null, lojaNova: boolean): Promise<RespostaSobreAlteracoes> {
		this.destino = destino
		this.alteracoes = alteracoes
		this.lojaNova = lojaNova
		this.mostra = true
		// O foco vai para a ação principal, como no desenho: Enter confirma e Esc fecha. Sem rolar o diálogo para
		// chegar ao botão, que cortava o texto à esquerda quando os botões não cabiam numa linha.
		setTimeout(() => {
			const principal = this.$refs.principal as Vue | undefined
			if (principal) (principal.$el as HTMLElement).focus({ preventScroll: true })
		}, 120)
		return new Promise(resolve => {
			this.resolver = resolve
		})
	}

	responder(resposta: RespostaSobreAlteracoes) {
		this.mostra = false
		if (this.resolver) this.resolver(resposta)
		this.resolver = null
	}
}
